/*
 *
 * Users constants
 *
 */

export const FLUSH_STATE = 'app/Users/FLUSH_STATE';

export const LOAD_USERS = 'app/Users/LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'app/Users/LOAD_USERS_SUCCESS';
export const LOAD_USERS_ERROR = 'app/Users/LOAD_USERS_ERROR';

export const UPDATE_USER = 'app/Users/UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'app/Users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'app/Users/UPDATE_USER_ERROR';
